import MessageFormat from "messageformat";

export const FORMAT_TYPES = {
    format: { text: "Format", value: "format" },
    messageformat: { text: "MessageFormat", value: "messageformat" },
    plain: { text: "Plain", value: "plain" },
    template: { text: "Template", value: "template" },
};

export class TranslationsFunctions {
    public static checkMessageFormat(input: any, inputName: string) {
        const value: string = input.val();
        const openBracket = "{";
        const closeBracket = "}";
        const messageType: string = input.closest("td").next().text();
        if (
            input.is(`[name='${inputName}']`) &&
            messageType === FORMAT_TYPES.format.text &&
            value !== "" &&
            (value.includes(openBracket) || value.includes(closeBracket))
        ) {
            input.attr("data-messageFormatValidation-msg", "Looks like you forgot to close brackets");
            const openBrLength: number = value.split(openBracket).length;
            const closeBrLength: number = value.split(closeBracket).length;
            return openBrLength === closeBrLength;
        }
        return true;
    }

    public static compileMessage(input: any, inputName: string) {
        const val = input.val();
        const locale = localStorage.getItem("locale") || "en";

        const $mf = new MessageFormat(locale);
        const messageType: string = input.closest("td").next().text();
        if (input.is(`[name='${inputName}']`) && messageType === FORMAT_TYPES.messageformat.text) {
            try {
                $mf.compile(val);
                return true;
            } catch (error) {
                input.attr("data-compileMessageFormatValidation-msg", `Error: ${error.message}`);
                return false;
            }
        }
        return true;
    }
}
